<template>
  <O3D>
    <SwatWalk></SwatWalk>
    <O3D :sx="5" :sy="5" :sz="5" :pz="-50">
      <O3D :px="0" :pz="10" :py="50">
        <PointLight :decay="2" :distance="0" :color="0xffffff" :helper="isDev && isOff" :intensity="0.4"></PointLight>
      </O3D>

      <O3D :px="0" :pz="-10" :py="18">
        <PointLight :decay="2" :distance="0" :color="0xffffff" :helper="isDev && isOff" :intensity="0.4"></PointLight>
      </O3D>

      <O3D :px="25" :pz="25" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="-25" :pz="25" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="25" :pz="-25" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="-25" :pz="-25" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="0" :pz="0" :py="0">
        <AmbinetLight :color="0xffffff" :helper="isDev && isOff" :intensity="0.2"></AmbinetLight>
      </O3D>
    </O3D>

    <GameNPC v-if="chroma && ready" :px="7" :pz="-20" :char="'mann-mid-poly'" :dance="'House Dancing'"></GameNPC>
    <GameNPC v-if="chroma && ready" ref="npc" :pz="-15" :char="'mann-mid-poly'" :dance="'House Dancing'"></GameNPC>
    <GameNPC v-if="chroma && ready" :px="-7" :pz="-20" :char="'mann-mid-poly'" :dance="'House Dancing'"></GameNPC>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { Actions } from '../../GLContent/Game/Actions.js'
import { CharNPC } from '../../GLContent/Game/CharNPC.js'
import { ShaderCubeChrome } from '../../Reusable/ShaderCubeChrome'
import { Color, Vector3 } from 'three'
// import { PCamera } from '../../Reusable/PCamera'
export default {
  mixins: [O3DG2],
  data () {
    return {
      // mainChar: window.innerWidth >= 1280 ? 'swat' : 'suzie',
      chroma: false,
      ready: false,
      layouts: {}
    }
  },
  methods: {
    async setup () {
      let lay = this.layouts
      this.onLoop(() => {
        lay.overall = {
          pz: -50
        }
      })
    }
  },
  async mounted () {
    this.setup()

    this.chroma = new ShaderCubeChrome({
      res: 32,
      renderer: this.ctx.renderer,
      loop: this.onLoop,
      color: new Color('#ffffff')
    })

    this.ctx.camera.position.z = 10
    this.ctx.camera.position.y = 13

    let v3 = new Vector3()
    let lerper = v3.clone()
    this.onLoop(() => {
      if (this.$refs.npc) {
        if (this.$refs.npc.npc && this.$refs.npc.npc.isReady) {
          this.$refs.npc.npc.skeleton.mixamorigHead.updateMatrixWorld()
          v3.setFromMatrixPosition(this.$refs.npc.npc.skeleton.mixamorigHead.matrixWorld)
          lerper.lerp(v3, 0.1)
          // this.ctx.camera.position.z = 10
          // this.ctx.camera.position.y = v3.y
          this.ctx.camera.lookAt(lerper)
        }
      }
    })
    await Promise.all([
      Actions.preloadByName({ name: 'House Dancing' }),
      // CharNPC.preloadByName({ name: 'swat' }),
      CharNPC.preloadByName({ name: 'mann-mid-poly' })
    ])
    this.ready = true
  }
}
</script>

<style>

</style>